import styled from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: inline-flex;
  width: ${props => props.theme.width || '200px'};
  height:  ${props => props.theme.height || '100px'};
  max-height: ${props => props.theme.maxHeight || 'none'};

  ${Media.lg`
    width: ${props => props.theme.width || '160px'};
    height: 80px;
  `}

  ${Media.md`
    width: ${props => props.theme.width || '140px'};
    height: 60px;
  `}

  ${Media.sm`
    width: ${props => props.theme.width || '120px'};
    height: 40px;
  `}
`;

export const Link = styled(RouterLink)`
  position: relative;
  display: inline-block;
  max-width: 100%;
  height: 100%;
`;

export const Image = styled.img`
  display: block;
  width: ${props => props.theme.width || '100%'};
  height: 100%;
  margin: 0;
  object-fit: contain;
`;

export const Source = styled.source``;

export const Mourning = styled.img`
  position: absolute;
  display: block;
  max-width: 50%;
  max-height: 50%;
  right: 0;
  bottom: 0;
`;
